import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=1a1f308e&scoped=true"
import script from "./ProgramPreview.vue?vue&type=script&lang=js"
export * from "./ProgramPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&id=1a1f308e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f308e",
  null
  
)

export default component.exports